import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_DASHBOARD_DECISION_MAKER_OUTREACH = defineFcm(
	'starter_experience_dashboard_decision_maker_outreach',
)
	.asJson(
		z.object({
			experimentName: z.string().optional(),
			enabled: z.boolean().optional(),
			/** ISO date the feature was turned on. Petitions created before it get the DM tab "New" nav badge. */
			launchedAt: z.string().optional(),
		}),
	)
	.withDefault({
		experimentName: 'starter_experience_dashboard_decision_maker_outreach_experiment',
		enabled: false,
	})
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard',
		description: 'Gates the Decision Maker outreach ("contact decision makers") A/B experiment.',
		template: {
			experimentName: 'starter_experience_dashboard_decision_maker_outreach_experiment',
			enabled: false,
			launchedAt: '2026-01-01T00:00:00.000Z',
		},
	});
